import { useState } from 'react';

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@base/Dialog';
import { ButtonPrimary, ButtonDefault } from '@base/Button/Button';

export const DialogConfirm = (props) => {
    const [loading, setLoading] = useState(false);

    const actions = () => {
        return (
            <>
                <ButtonPrimary
                    disabled={loading}
                    onClick={() => { setLoading(true); props.handleConfirm(props.id, setLoading) }}
                    startIcon={loading ? <CircularProgress size={16} /> : <CheckOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Confirmar"
                />
                <ButtonDefault
                    onClick={props.close}
                    startIcon={<ClearOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Cancelar"
                />
            </>
        )
    }

    return (
        <>
            <Dialog
                openDialog={props.open}
                title={props.title}
                closeDialog={props.close}
                actions={actions()}
                fullWidth={true}
                maxWidth={props.maxWidth ?? "md"}
            >
               <div dangerouslySetInnerHTML={{ __html: props.text }} />
               {props.children}
            </Dialog>
        </>
    )
}

export default DialogConfirm;
